import React from "react";
import { Helmet } from "react-helmet-async";

/**
 * Reusable SEO block. Injects title, description, OG, Twitter, canonical.
 * Combine with react-helmet-async's HelmetProvider (wraps <App />).
 */
const SITE = "https://freeayto.de";
const DEFAULT_IMAGE =
  "https://freeayto-preview.preview.emergentagent.com/api/uploads/freeayto-og.jpg";

const SEO = ({
  title,
  description,
  path = "/",
  image = DEFAULT_IMAGE,
  type = "website",
  keywords,
}) => {
  const url = `${SITE}${path}`;
  const fullTitle = title
    ? `${title} · FREEAYTO Media`
    : "FREEAYTO – Social Media mit Struktur. Content mit Wirkung.";
  const desc =
    description ||
    "FREEAYTO Media Agency aus Dortmund – Performance-Content, UGC und Social Media Strategie für Premium-Brands. Aldi, Subway, Five Guys & mehr.";
  return (
    <Helmet prioritizeSeoTags>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={url} />

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="FREEAYTO Media" />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:image" content={image} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:alt" content="FREEAYTO Media – Social Media Agency Dortmund" />
      <meta property="og:locale" content="de_DE" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
};

export default SEO;
